import { createClient } from '@supabase/supabase-js'
import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'
import type { Database } from '@/types/supabase'
import { logWarn } from '@/lib/log'
import { AUTH_SABITLERI } from '@/lib/clientConfig'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

// Capacitor native platformlar için güvenli storage adapter (Preferences + localStorage Fallback)
const capacitorStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      if (Capacitor.isPluginAvailable('Preferences')) {
        const { value } = await Preferences.get({ key })
        return value
      }
    } catch (e) {
      logWarn('[Storage] Preferences.getItem hatası, localStorage kullanılıyor:', e)
    }
    return localStorage.getItem(key)
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      if (Capacitor.isPluginAvailable('Preferences')) {
        await Preferences.set({ key, value })
        return
      }
    } catch (e) {
      logWarn('[Storage] Preferences.setItem hatası, localStorage kullanılıyor:', e)
    }
    localStorage.setItem(key, value)
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      if (Capacitor.isPluginAvailable('Preferences')) {
        await Preferences.remove({ key })
        return
      }
    } catch (e) {
      logWarn('[Storage] Preferences.removeItem hatası, localStorage kullanılıyor:', e)
    }
    localStorage.removeItem(key)
  }
}

/**
 * 🎓 Master Class Blueprint: Single Source of Truth for DB Client
 * Tip güvenli Supabase istemcisi - Tüm sorgular Database tipi ile kontrol edilir
 */
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: capacitorStorage,
    // Degerler `clientConfig.ts`te; orada testleri var.
    ...AUTH_SABITLERI,
    detectSessionInUrl: !Capacitor.isNativePlatform()
  }
})

// ⚠️ SEC-2 Fix: Admin client (getAdminClient) kaldırıldı.
// Service Role Key sadece Supabase Edge Functions içinde kullanılmalıdır.
// Frontend'de bu key'e hiçbir koşulda erişilmemelidir.

// Tip dışa aktarımları
export type { Database }
